import { useSelector, useDispatch } from '../actions/types';
import { Actions as SearchActions } from '../actions/search';
import { ISearchResult } from '../types';
import { Maybe } from '../utils/types';

export type SearchResultsHook = {
  isFetching: boolean;
  results: Maybe<ReadonlyArray<ISearchResult>>;
  searchTerm: string | null;
  hasMore: boolean;
  totalCount: number | null;
  loadMore: () => void;
  clearResults: () => void;
};

export default function useSearchResults(): SearchResultsHook {
  const dispatch = useDispatch();
  const results = useSelector((state) => state.search.results);
  const searchTerm = useSelector((state) => state.search.searchedTerm);
  const isFetching = useSelector((state) => state.search.isFetching);
  const totalCount = useSelector((state) => state.search.totalCount);
  const currentPage = useSelector((state) => state.search.currentPage);
  const totalPages = useSelector((state) => state.search.totalPages);
  const hasMore = currentPage && totalPages ? currentPage < totalPages : false;

  const loadMore = () => {
    if (!currentPage || !searchTerm || !hasMore) return;
    dispatch(
      SearchActions.searchRequest({ query: searchTerm, page: currentPage + 1 })
    );
  };

  const clearResults = () => dispatch(SearchActions.searchReset());

  return {
    isFetching,
    searchTerm,
    hasMore,
    results,
    loadMore,
    totalCount,
    clearResults,
  };
}
